import React from 'react'
import { Link } from 'react-router-dom';

const HomeThumbnails = ({ id, src, title, publisher }) => {

    return (
         <Link to={`/video/${id}`} className="block">
            <div className='mx-5 mb-2'>
                <img 
                src={src} 
                alt ={title}
                className='w-full w-[525px] md:w-[600px] lg:w-[400px] rounded-lg aspect-video overflow-hidden' 
                />
                <div>
                    <p className="font-medium">{title}</p>
                    <p className="text-gray-400 text-sm">{publisher}</p>
                </div>
            </div>
        </Link>
    )
}

export default HomeThumbnails
